import { render, staticRenderFns } from "./modalShare.vue?vue&type=template&id=365319f8"
import script from "./modalShare.vue?vue&type=script&lang=js"
export * from "./modalShare.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports